export default __webpack_public_path__ + "static/media/resetPassword.1ee29f8c.jpg";